import { render, staticRenderFns } from "./Task_StudentSituation.vue?vue&type=template&id=2c9cedf1&scoped=true&"
import script from "./Task_StudentSituation.vue?vue&type=script&lang=js&"
export * from "./Task_StudentSituation.vue?vue&type=script&lang=js&"
import style0 from "./Task_StudentSituation.vue?vue&type=style&index=0&id=2c9cedf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9cedf1",
  null
  
)

export default component.exports